import { capitalize, startCase } from 'lodash';

export const printStringArray = (arr: string[], capitalized = false): string => {
  const result = arr.reduce((acc, value, idx) => {
    if (idx === 0) {
      return `${capitalized ? capitalize(startCase(value)) : startCase(value)}`;
    }
    return `${acc}, ${capitalized ? capitalize(startCase(value)) : startCase(value)}`;
  }, '');

  return result;
};

export const handleUnicode = (text: string): string =>
  text.replace(/\\u[\dA-F]{4}/gi, (match) =>
    String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
  );

export const handleEscaped = (text: string): string => {
  const result = text.replace(/(?!\\u)(\\[a-z]{1})/gi, (match) => {
    switch (match) {
      case '\\n':
        return '\n';
      case '\\t':
        return '\t';
      case '\\v':
        return '\v';
      case '\\b':
        return '\b';
      case '\\r':
        return '\r';
      default:
        return '';
    }
  });
  return result;
};

export default (text: string): string => {
  const result = handleUnicode(text);
  return handleEscaped(result);
};

export const verifyEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const verifyStringNumber = /^\s*[+-]?(\d+|\d*\.\d+|\d+\.\d*)([Ee][+-]?\d+)?\s*%*$/;

export const parseTeamsEmojis = (text: string): string => {
  const split = text.split(/<emoji.*?alt="(.*?)".*?emoji>/);
  return split.reduce((acc, v) => acc + v);
};
